export default __webpack_public_path__ + "static/media/buAddIcon.09ff3eaf.svg";